import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr } from '../../models/data.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../../models/data.js.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IconViewClass;
function IconView() {
  if (IconViewClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        this.tb5_1.eb9('role', 'img');
        this.tb5_1.hb4_1.v('viewDraws');
        this.tb5_1.hb4_1.v('icon');
        this.obt_1 = null;
        this.pbt_1 = null;
      }
      ub9(index, view) {
        super.ub9(index, view);
        Companion_instance.lbg(this, index, view);
      }
      qbt(value) {
        this.obt_1 = value;
        this.tb5_1.zb9();
        if (value == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this.tb5_1;
          // Inline function 'kotlin.apply' call
          var this_0 = new (FutureElement())();
          this_0.xb3_1 = 'svg';
          this_0.wb3_1 = 'http://www.w3.org/2000/svg';
          var tmp0 = this_0.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_0 = _Dimension___get_value__impl__urhqzr(value.rbt_1).toString();
          tmp0.fb7_1.width = value_0;
          var tmp0_0 = this_0.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_1 = _Dimension___get_value__impl__urhqzr(value.sbt_1).toString();
          tmp0_0.fb7_1.height = value_1;
          this_0.ab9('fill', 'currentColor');
          this_0.ab9('stroke', 'currentColor');
          this_0.ab9('stroke-width', '0');
          // Inline function 'kotlin.run' call
          var tmp$ret$3 = '' + value.tbt_1 + ' ' + value.ubt_1 + ' ' + value.vbt_1 + ' ' + value.wbt_1;
          this_0.eb9('viewBox', tmp$ret$3);
          var _iterator__ex2g4s = value.xbt_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var path = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.apply' call
            var this_1 = new (FutureElement())();
            this_1.xb3_1 = 'path';
            this_1.wb3_1 = 'http://www.w3.org/2000/svg';
            this_1.eb9('d', path);
            this_0.zbt(this_1);
          }
          var _iterator__ex2g4s_0 = value.ybt_1.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var path_0 = _iterator__ex2g4s_0.o1();
            // Inline function 'kotlin.apply' call
            var this_2 = new (FutureElement())();
            this_2.xb3_1 = 'path';
            this_2.wb3_1 = 'http://www.w3.org/2000/svg';
            this_2.ab9('stroke-width', get_px(path_0.abu_1).toString());
            var tmp0_safe_receiver = path_0.dbu_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bb2();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.paz();
            this_2.ab9('fill', tmp2_elvis_lhs == null ? 'none' : tmp2_elvis_lhs);
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$7 = path_0.cbu_1.toString().toLowerCase();
            this_2.ab9('stroke-linecap', tmp$ret$7);
            this_2.eb9('d', path_0.bbu_1);
            this_0.zbt(this_2);
          }
          tmp.zbt(this_0);
        }
      }
      ebu(value) {
        this.pbt_1 = value;
        var tmp0_safe_receiver = firstOrNull(this.tb5_1.oba());
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.find' call
          var tmp0 = tmp0_safe_receiver.oba();
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.xb3_1 === 'title') {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_safe_receiver_0 = tmp$ret$1;
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp0_safe_receiver_0.fbu(value);
            tmp = Unit_instance;
          }
          if (tmp == null) {
            // Inline function 'kotlin.apply' call
            var this_0 = new (FutureElement())();
            this_0.xb3_1 = 'title';
            this_0.fbu(value);
            tmp0_safe_receiver.zbt(this_0);
          }
        }
      }
    }
    initMetadataForClass($, 'IconView');
    IconViewClass = $;
  }
  return IconViewClass;
}
//region block: exports
export {
  IconView as IconView32wln42r1v8cb,
};
//endregion

//# sourceMappingURL=IconView.commonHtml.mjs.map
